import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { productAlertOverrides } from "./constants";
import type { ProductAlertOverridesResult } from "./types";
import { isProductAlertOverridesResult } from "./validators";

/** The ids of the app group alerts a Canvas is excluded from. */
export const getProductAlertOverrides = reactQueryFetcherAdapter(
  productAlertOverrides,
  (signal: AbortSignal, canvasId: string): Promise<ProductAlertOverridesResult> => {
    return fetch("/product_alerts/overrides", "GET", { canvas_id: canvasId }, { signal });
  },
  isProductAlertOverridesResult
);
